module.exports = __webpack_public_path__ + "img/q-form-right-pattern.fc65919d.png";